import { Ref } from 'vue';
import { RefElement, useEvent, wrap } from 'vue-composable';

export const useOnOutsidePress = (
  refElement: RefElement,
  callback: (e: MouseEvent | TouchEvent) => void,
  ignoredQueries?: Array<string>
) => {
  const element: Ref<Element | null> = wrap(refElement);
  const clickHandler = (e: MouseEvent | TouchEvent) => {
    element.value &&
      !ignoredQueries?.some(id => {
        const elements = document.querySelectorAll(id);
        return [...elements].some(el => el?.contains(e.target as Node) || (e.target as Node).contains(el));
      }) &&
      !element.value.contains(e.target as Node) &&
      callback(e);
  };

  return useEvent(document, 'mousedown', clickHandler, { passive: true });
};
